
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import EventBus from '../../eventBus'
  import { required } from 'vuelidate/lib/validators'
  import { Validations } from 'vuelidate-property-decorators'
  
  @Component
  export default class ManageProjectClass extends Vue {
      @Validations()
      validations = {
          projectClass: {
              property: { required },
          }
      }
      activeScreen: string = 'main'
      loadingMessage: string = 'Please wait while we create new project class'
      loadingTitle: string = 'Saving...'
      additionalSuccessMessage: string = ''
      successMessage: string = 'New Project Class Created Successfully'
      links: Array<object> = [
          {
              text: 'Chart Settings',
              to: '/chart-settings'
          },
          {
              text: 'Manage Project Class',
              active: true
          }
      ]
      error: any = {
          generalMessage: '',
          errors: []
      }
      projectClass: any = {
          property: '',
          backgroundColor: '',
          textColor: '',
      }
      activeItem: any = null
      formErrors: string[] = []
  
      // METHODS
      checkErrors() {
          this.formErrors = []
  
          if(this.projectClass.property.length < 1) {
              this.formErrors.push('Project Class is Required')
          }
      }
      
      newActivity(){
          this.projectClass.property = '';
          this.$v.$reset()
      }
  
      persistData(){
          this.activeScreen = 'loading';
          EventBus.$emit('activeScreen', this.activeScreen)        
          if(this.activeItem == null)
              this.saveNew();
          else
              this.update();
      }
  
      update(){
          this.activeScreen = 'loading'
          EventBus.$emit('activeScreen', this.activeScreen)
          this.loadingMessage = 'Please wait while we update this project class'
          this.loadingTitle = 'Saving...'
          var payload = this.createPayload()
          this.$store.dispatch('settingsModule/updateColorSetting', payload)
          .then((res: any) => 
              {
                  this.activeScreen = 'successNoGotIt'
                  EventBus.$emit('activeScreen', this.activeScreen)
                  this.additionalSuccessMessage = ''
                  this.successMessage = 'Project Class Updated Successfully'
              }
          ).catch((err: any) => {
              this.activeScreen = 'error'
              EventBus.$emit('activeScreen', this.activeScreen)
              this.error.generalMessage = err.message
          })
      }
   
      createPayload() {
          return {
              settingType: 'ProjectClass',
              propertyName: this.projectClass.property,
              id: this.activeItem ? this.activeItem.id : 0,
              backgroundColor:  typeof(this.projectClass.backgroundColor)=='string'?this.projectClass.backgroundColor:this.projectClass.backgroundColor.hex,
              textColor:  typeof(this.projectClass.textColor)=='string'?this.projectClass.textColor:this.projectClass.textColor.hex,
          }
      }
  
      saveNew(){
          var payload = this.createPayload()
          this.$store.dispatch('settingsModule/mutateColorSetting', [payload])
          .then((res: any) =>
              {
                  this.activeScreen = 'successRemain'
                  EventBus.$emit('activeScreen', this.activeScreen)
                  this.additionalSuccessMessage = 'You can now use the new project class'
                  this.successMessage = 'Successfully Created '+ payload.propertyName
                  this.newActivity()
              }
          ).catch((err: any) => {
              this.activeScreen = 'error'
              EventBus.$emit('activeScreen', this.activeScreen)
              this.error.generalMessage = err.message
          })
      }
  
  
  
      // VUEX METHODS
  
      // COMPUTED PROPERTIES
      get getProjectSettings () {
        return this.$store.getters['settingsModule/getSettingsProject']
    }
    get fetchColorSettings() {
        return this.$store.dispatch('settingsModule/getColorSettings')
    }
      
      get isButtonDisabled(): boolean {
          if (this.formErrors.length > 0) {
              return true
          } else {
              return false
          }
      }
  
      // CREATED
      created() {
        this.fetchColorSettings.then(() => {
            if(this.$route.query.id){
                this.activeItem = this.getProjectSettings.find((i: any) => i.id == this.$route.query.id)

                this.projectClass.property = this.activeItem.propertyName,
                this.projectClass.backgroundColor = this.activeItem.backgroundColor;
                this.projectClass.textColor = this.activeItem.textColor;
          }else{
              this.checkErrors()
          }
        });
      }
  }
  
  